import { render, staticRenderFns } from "./modalConfigGateway.vue?vue&type=template&id=9bdc6182"
import script from "./modalConfigGateway.vue?vue&type=script&lang=js"
export * from "./modalConfigGateway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports